export * from './qms-ticket-result.service';
